<p-toast></p-toast>
<div class="file-tree">
  <p-tree
    [ngClass]="{'populated' : nodes.length > 0}"
    id="tree"
    [value]="nodes"
    scrollHeight="100%"
    (onNodeExpand)="onNodeExpand($event)"
    (onNodeCollapse)="onNodeCollapse($event)"
    [loading]="loadingTree && nodes.length === 0"
    selectionMode="single"
    [(selection)]="selectedNode"
    (onNodeSelect)="onNodeSelect($event)"
    (onNodeUnselect)="onNodeSelect($event)"
    [contextMenu]="treemenu"
    (onNodeContextMenuSelect)="onNodeContextMenuSelect($event)"
  >
    <ng-template let-node pTemplate="default">
      {{ node.label }}
      <span *ngIf="showFolderLoader(node)">
        <p-progressSpinner styleClass="loading-node" strokeWidth="6"></p-progressSpinner>
      </span>
      <div *ngIf="node.data | instanceof: IFile as file">
        <span class="text-xs font-italic text-primary">
          {{ node.data.size | filesize }}
        </span>
      </div>
    </ng-template>
    <ng-template let-node pTemplate="loadmore">
      <button class="load-more-btn" (click)="onLoadMore($event, node)">More...</button>
    </ng-template>
    <ng-template let-node pTemplate="loadingmore">
      <p-progressSpinner styleClass="loading-node" strokeWidth="6"></p-progressSpinner>
    </ng-template>
  </p-tree>
</div>

<p-dialog [(visible)]="showDownloadDialog" header="Downloading File" [closable]="false">
  <p>Downloading: {{ downloadingFileName }}</p>
  <p-progressBar [value]="downloadProgress"></p-progressBar>
  <ng-template pTemplate="footer">
    <button pButton label="Cancel" (click)="onCancelDownload()"></button>
  </ng-template>
</p-dialog>

<p-contextMenu #treemenu [model]="treeMenu"></p-contextMenu>
